import { StringFilterOperation } from "abweb/dto/generated/inputargs/StringFilterOperation";
import { StringFilterValueBase } from "abweb/dto/generated/inputargs/StringFilterValueBase";
export class StringFilterValue extends StringFilterValueBase {
  static createStringFilterValue(isCaseSensitive, isOpNegated, op, value) {
    const retVal = new StringFilterValue();
    retVal.initStringFilterValue(null, isCaseSensitive, isOpNegated, op, value);
    return retVal;
  }
  constructor() {
    super();
    this.initStringFilterValue(null, false, false, StringFilterOperation.Contains, null);
  }
  get isCaseSensitive() {
    return super.isCaseSensitive;
  }
  set isCaseSensitive(value) {
    super.isCaseSensitive = value;
  }
  get isOpNegated() {
    return super.isOpNegated;
  }
  set isOpNegated(value) {
    super.isOpNegated = value;
  }
  get op() {
    return super.op;
  }
  set op(value) {
    super.op = value;
  }
  get value() {
    return super.value || "";
  }
  set value(value) {
    super.value = value || null;
  }
  clone() {
    return StringFilterValue.createStringFilterValue(this.isCaseSensitive, this.isOpNegated, this.op, this.value);
  }
}
//# sourceMappingURL=StringFilterValue.js.map
